import { useMutation } from '@tanstack/react-query'
import { apiClient } from '~/shared/api/data-ingestion-api'

export function useCreatePatientMatch() {
  return useMutation({
    ...apiClient.addPatientRecordDocumentsKeyPatientMatchesRecordsPostMutation(),
  })
}
